import { axios } from '@/plugins/http-axios';
import cons from '@/store/cons';
import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { IData } from '@/types/globalTypes';
import { IFile, TClientDoc } from '@/types/docTypes';
import { isLkkAppClient } from '@/types';
interface IEnvLkk {
  [key: string]: string | boolean;
}
interface IFlag {
  code: string;
  desc: string;
  value: boolean;
  affectedSystems: string[];
}
export interface IParameter {
  code: string;
  desc: string;
  value: string;
  resulttype: string;
}
interface ISystemInfo {
  flags: IFlag[];
  parameters: [];
}

interface IEnvState {
  env: {
    flags: IFlag[];
    parameters: IParameter[];
    lkk: IEnvLkk;
  };
  cons: IData;
}
export default <Module<IEnvState, RootState>>{
  state: {
    env: {
      flags: [],
      parameters: [],
      lkk: {},
    },
    cons: cons,
  },
  mutations: {
    setEnv(state, data: ISystemInfo) {
      state.env.flags = data.flags;
      state.env.parameters = data.parameters;
    },
    setEnvLkk(state, data: IEnvLkk = {}) {
      state.env.lkk = data;
    },
  },
  actions: {
    async getEnvLkk({ commit, dispatch, rootGetters }) {
      //todo перенести этот зарос в getEnv
      return axios
        .get<IEnvLkk>(rootGetters.uri.env)
        .then((resp) => {
          commit('setEnvLkk', resp.data);
          return Promise.resolve();
        })
        .catch((e) => {
          e.uri = rootGetters.uri.env;
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    async getEnv({ commit, dispatch, rootGetters }) {
      //todo выпилить i18n из ответа и перенести в запросы i18n
      return axios
        .get(rootGetters.uri.infoSystemInfo)
        .then((resp) => {
          commit('setI18nBank', resp.data.i18n, { root: true });
          commit('setEnv', resp.data);

          const title = document.querySelector('title');
          if (title) {
            title.innerHTML = resp.data.i18n.LKB_TITLE || '';
          }

          return Promise.resolve();
        })
        .catch((e) => {
          e.uri = rootGetters.uri.infoSystemInfo;
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
  },
  getters: {
    envLkk: (state): IEnvLkk => state.env.lkk,
    cons: (state): IData => state.cons,
    trBgColorClientDoc:
      (state, getters, rootState, rootGetters) =>
      (file: IFile, docType: TClientDoc): string => {
        if (!isLkkAppClient(docType.subType)) {
          if (file.doc?.confirmResult) {
            if (file.doc.confirm) {
              return rootGetters.theme.customerDocumentsValid; //Зелёный
            } else {
              return rootGetters.theme.customerDocumentsNotValid;
            } //Красный
          }

          if (file.isSignFinished) return rootGetters.theme.customerDocumentsValid; //Зелёный
        }

        if (file.type === state.cons.APP_DOC_TYPE_REQ) return '#ddd'; //Белый
        switch (file.status) {
          case rootGetters.cons.APP_DOC_STATUS_FOR_CHECK:
            return rootGetters.theme.customerDocumentsForCheck; //Желтый
          case rootGetters.cons.APP_DOC_STATUS_VALID:
            return rootGetters.theme.customerDocumentsValid; //Зелёный
          case rootGetters.cons.APP_DOC_STATUS_NOT_VALID:
            return rootGetters.theme.customerDocumentsNotValid; //Красный
          case rootGetters.cons.APP_DOC_STATUS_PROCESS:
            return rootGetters.theme.customerDocumentsProcess; //Голубой
          default:
            return '';
        }
      },

    //todo Нужно переделать на объект по ключам code
    flag:
      (state) =>
      (code: string): boolean => {
        const flag = state.env.flags.find((flag) => flag.code === code);
        return flag ? flag.value : false;
      },
    isRequestForAdditionalDoc: (state, getters): boolean => getters.flag('REQUEST_FOR_ADDITIONAL_DOCUMENTS'),
    isDarkTheme: (state, getters): boolean => getters.flag('DARK_THEME_ACTIVATE'),
    //todo Нужно переделать на объект по ключам code
    sysParameter:
      (state) =>
      (code: string): IParameter | undefined =>
        state.env.parameters.find((p) => p.code === code),
    finalResultContract: (state, getters): boolean | undefined =>
      getters.sysParameter('FINAL_RESULT')?.value == 'contract' || false,

    /*
        finalResultName: (state, getters):string => {

            const finalResult:IParameter|undefined = getters.finalResult;
            let finalResultName = '';

            if (finalResult)
                for (let type in finalResult.variants)
                    if (type === finalResult.value)
                        finalResultName = finalResult.variants[type].value;

            return finalResultName;
        },
*/
    isAgent: (state, getters): boolean => getters.flag('ENABLE_LKK_AGENT'),
    isNewQuestionnaireMode: (state, getters): boolean => getters.flag('IS_NEW_QUESTIONNAIRE_MODE'),
    isCreditConveyor: (state, getters): boolean => getters.flag('CREDIT_CONVEYOR_ENABLE'),
    isHideOffice: (state, getters): boolean => getters.flag('HIDE_OFFICE'),
    isComment: (state, getters): boolean => getters.flag('SHOW_COMMENT'),
    isDynamicSec: (state, getters): boolean => getters.flag('DYNAMIC_SECTIONS'),
    isTwoSideSigningOfDocumentsEp: (state, getters): boolean => getters.flag('BILATERAL_SIGNING_OF_DOCUMENTS_EP'),
    isSigningUnepDocument: (state, getters): boolean => getters.flag('SIGNING_UNEP_DOCUMENTS'),
    isUnepFioSn: (state, getters): boolean => getters.flag('UNEP_FIO_SN'),
    isRequestDigitalProfileFl: (state, getters): boolean => getters.flag('REQUEST_DIGITAL_PROFILE_FL'),
    isDiadoc: (state, getters): boolean => getters.flag('DIADOC_ENABLE'),
    hideSectionsEnable: (state, getters): boolean => getters.flag('HIDE_SECTIONS_ENABLE'),
    isDynamicSectionAppData: (state, getters): boolean => getters.flag('DYNAMIC_SECTION_APPDATA_ENABLE'),
    isConveyorIndividuals: (state, getters): boolean => getters.flag('CONVEYOR_INDIVIDUALS'),
    isSmartanApi: (state, { flag }) => flag('SMARTAN_API'),
    isCredConvXPIntegShowOption: (state, { flag }) => flag('CREDCONV_XP_INTEG_SHOW_OPTION'),
    isOriginFilenameEnable: (state, { flag }) => flag('ORIGIN_FILENAME_ENABLE'),
    isRequestForAdditionalDocuments: (state, { flag }) => flag('REQUEST_FOR_ADDITIONAL_DOCUMENTS'),

    isMonitoringJournalEnable: (state, { flag }) => flag('MONITORING_JOURNAL_ENABLE'),
    isEmailInsteadOfParticipant: (state, { flag }) => flag('EMAIL_INSTEAD_OF_PARTICIPANT'),
    isConfirmParentValue: (state, { flag }) => flag('QUESTIONNAIRE_CONFIRM_PARENT_VALUE'),
    isShowOrgStatusEnabled: (state, getters): boolean => getters.envLkk.SHOW_ORG_STATUS_ENABLED,
    showOrgStatus: (state, getters): string[] => (getters.isShowOrgStatusEnabled ? getters.envLkk.SHOW_ORG_STATUS : []),
    isSignClientsDocuments: (state, { flag }) => flag('SIGN_CLIENTS_DOCUMENTS'),
  },
};
